<template>
    <time-material
        :value="currentValue"
        :placeholder="$t('请选择来访时间')"
        :valid="valid"
        @change="onChange"
    />
</template>

<script>
import TimeMaterial from './template/time-material';
import { selectTwoLevelValidator } from './validate';

export default {
  name: 'VisitingTime',

  components: {
    TimeMaterial,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    let currentValue = this.value || {};
    if (!currentValue.value) {
      currentValue = {
        operand: 'include',
        value: null,
      };
    }
    return {
      currentValue,
      valid: true,
    };
  },
  computed: {
    brief() {
      const selectText = !this.currentValue.value ? '' : this.currentValue.value.map(item => item.name).join(',');
      return this.$t('{text}为{value}', { text: this.optionInfo.text, value: selectText });
    },
  },

  watch: {
    value(newValue) {
      this.currentValue = newValue;
      if (!this.currentValue.value) {
        this.currentValue = {
          operand: 'timePeriods',
          value: null,
        };
      }
    },
  },

  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    validate() {
      this.valid = selectTwoLevelValidator(this.currentValue);
      return this.valid;
    },
    onChange(value) {
      this.valid = true;
      this.currentValue = value;
      const ruleData = {
        name: 'visitingTime',
        type: 'remoteDateTime',
        operation: 'timePeriods',
        value: JSON.stringify(this.getTimeIdArray(value.value)),
      };
      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: selectTwoLevelValidator(value),
      });
    },
    getTimeIdArray(value) {
      // 线上获取的id 是 string 类型，……
      return !value ? [] : value.map(item => Number(item.id));
    },
  },
};
</script>
